// eApp_Handlers.js

import { v4 as uuidv4 } from 'uuid';

export const eApp_handleSelectVideo = (setSelectedVideo) => (video) => {
  setSelectedVideo(video);
};

export const eApp_handleBackToCategories = (setSelectedVideo, setShowAccount) => () => {
  setSelectedVideo(null);
  setShowAccount(false);
};

export const eApp_handleEditVideo = (setVideos, selectedVideo, setSelectedVideo) => (category, index, updatedVideo) => {
  setVideos(prevVideos => ({
    ...prevVideos,
    [category]: prevVideos[category].map((v, i) => i === index ? updatedVideo : v)
  }));
  // Always update selectedVideo
  setSelectedVideo(updatedVideo);
};

// eApp_Handlers.js

export const eApp_handleReorderVideos = (setVideos) => (category, newVideos) => {
  setVideos((prevVideos) => ({
    ...prevVideos,
    [category]: newVideos,
  }));
};







// eApp_Handlers.js


export const eApp_handleAddVideo = (setVideos) => (category) => {
  const newVideo = {
    id: uuidv4(),
    title: 'New Video',
    description: 'Add description here',
    thumbnail: '',
    url: '',
    locked: false,
    isNew: false,
  };
  setVideos((prevVideos) => ({
    ...prevVideos,
    [category]: [...prevVideos[category], newVideo],
  }));
};



export const eApp_handleDeleteVideo = (setVideos) => (category, index) => {
  setVideos(prevVideos => ({
    ...prevVideos,
    [category]: prevVideos[category].filter((_, i) => i !== index)
  }));
};

export const eApp_handleAddCategory = (setCategories, setVideos) => (newCategory) => {
  setCategories(prevCategories => [...prevCategories, newCategory]);
  setVideos(prevVideos => ({
    ...prevVideos,
    [newCategory]: []
  }));
};

export const eApp_handleDeleteCategory = (setCategories, setVideos) => (category) => {
  setCategories(prevCategories => prevCategories.filter(c => c !== category));
  setVideos(prevVideos => {
    const { [category]: _, ...rest } = prevVideos;
    return rest;
  });
};

export const eApp_handleReorderCategories = (setCategories) => (newOrder) => {
  setCategories(newOrder);
};

export const eApp_handleToggleLockVideo = (setVideos) => (category, index) => {
  setVideos(prevVideos => ({
    ...prevVideos,
    [category]: prevVideos[category].map((v, i) => i === index ? { ...v, locked: !v.locked } : v)
  }));
};

export const eApp_handleToggleNewVideo = (setVideos) => (category, index) => {
  setVideos(prevVideos => ({
    ...prevVideos,
    [category]: prevVideos[category].map((v, i) => i === index ? { ...v, isNew: !v.isNew } : v)
  }));
};



export const eApp_handleSortEnd = (setVideos) => (category) => ({ oldIndex, newIndex }) => {
  setVideos((prevVideos) => {
    const newVideos = Array.from(prevVideos[category]);
    const [movedVideo] = newVideos.splice(oldIndex, 1);
    newVideos.splice(newIndex, 0, movedVideo);
    return {
      ...prevVideos,
      [category]: newVideos,
    };
  });
};
